// extracted by mini-css-extract-plugin
export var closeButton = "bC_d6";
export var dialogWrapper = "bC_d7";
export var mainContent = "bC_D";
export var modalWrapper = "bC_d5";